import { Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { YardIssueDto } from '../../models/yard-issue.model'
import { getImdgIssuePresentation } from '../../utils/imdg-issue-presentation.util'

interface Props {
  issue: YardIssueDto
}

export const IssueCardImdgDetails = ({ issue }: Props) => {
  const { t } = useTranslate()
  const presentation = getImdgIssuePresentation(issue)

  if (!presentation) return null

  return (
    <Typography variant='body2'>
      {t(presentation.detailKey, presentation.detailFallback, presentation.detailParams)}
    </Typography>
  )
}
